import React from 'react';
import { ModalHeader } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { VrrButton } from '../../../../../../../shared_components';
import { TPixelHeader } from './types';
import './PixelHeader.scss';

const PixelHeader: React.FC<TPixelHeader> = ({
  canAdd,
  onClickAction,
  onClearAction
}) => {
  const { t } = useTranslation();

  return (
    <ModalHeader
      className="vrr-modal-header"
      close={
        <div className="pixel-actions">
          <VrrButton
            className="btn-round pixel-modal-header-clear"
            onClick={onClearAction}
            icon={{
              iconLabel: 'tim-icons icon-simple-remove'
            }}
          >
            {t(
              'media_plan_edit.media_plan_config.pixel.modal_header.clear_button'
            )}
          </VrrButton>
          <VrrButton
            disabled={!canAdd}
            className="btn-round pixel-modal-header-add"
            onClick={onClickAction}
            icon={{
              iconLabel: 'tim-icons icon-simple-add'
            }}
          >
            {t(
              'media_plan_edit.media_plan_config.pixel.modal_header.add_button'
            )}
          </VrrButton>
        </div>
      }
    >
      <span>
        <i className="tim-icons icon-spaceship circle-icon" />
      </span>
      <span>
        {t('media_plan_edit.media_plan_config.pixel.modal_header.title')}
      </span>
    </ModalHeader>
  );
};

export default PixelHeader;
